import React from 'react';
function Ai({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M2.65 6c0-1.85 1.5-3.35 3.35-3.35h12c1.85 0 3.35 1.5 3.35 3.35v12c0 1.85-1.5 3.35-3.35 3.35H6A3.35 3.35 0 0 1 2.65 18V6Z" />
      <path
        d="m7 15.5.93-2.05m5.4 2.05-.92-2.05m-4.48 0 2.24-4.95 2.24 4.95m-4.48 0h4.48M16 15.5v-7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Ai;
